(() => {

  const STORAGE_KEY = 'horizon-second-image-toggle';

  window.productSecondImageToggle =
    localStorage.getItem(STORAGE_KEY) === 'true';

  function showSecondImages() {

    document.querySelectorAll('product-card').forEach((card) => {

      const slideshow = card.refs?.slideshow;

      if (!slideshow) return;

      slideshow.select(1, undefined, {
        animate: false
      });

    });

  }

  function showFirstImages() {

    document.querySelectorAll('product-card').forEach((card) => {

      const slideshow = card.refs?.slideshow;

      if (!slideshow) return;

      slideshow.select(0, undefined, {
        animate: false
      });

    });

  }

  function initializeToggle() {

    const toggle = document.querySelector('#product-image-toggle');

    if (!toggle) return;

    toggle.checked = window.productSecondImageToggle === true;

    if (toggle.dataset.initialized === 'true') {
      return;
    }

    toggle.dataset.initialized = 'true';

    toggle.addEventListener('change', () => {

      const enabled = toggle.checked;

      window.productSecondImageToggle = enabled;

      localStorage.setItem(
        STORAGE_KEY,
        enabled ? 'true' : 'false'
      );

      if (enabled) {
        showSecondImages();
      } else {
        showFirstImages();
      }

    });

    if (toggle.checked) {
      requestAnimationFrame(showSecondImages);
    }

  }

  document.addEventListener('DOMContentLoaded', initializeToggle);

  const observer = new MutationObserver(() => {

    initializeToggle();

    if (window.productSecondImageToggle === true) {
      requestAnimationFrame(showSecondImages);
    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();